<template>
  <div>
    <el-table :data="list" style="width: 100%">
      <el-table-column label="券号" align="center">
        <template slot-scope="scope">
          {{ scope.row.cardNumber }}
        </template>
      </el-table-column>
      <el-table-column label="券类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.type }}
        </template>
      </el-table-column>
      <el-table-column label="面值" align="center">
        <template slot-scope="scope">
          ￥{{ scope.row.value }}
        </template>
      </el-table-column>
      <el-table-column label="余额" align="center">
        <template slot-scope="scope">
          ￥{{ scope.row.balance }}
        </template>
      </el-table-column>
      <el-table-column label="到期日" align="center">
        <template slot-scope="scope">
          {{ scope.row.expirationDate | formatTime }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        :current-page="orderParam.pageNum"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="orderParam.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { cdkeyList } from '@/api/gift.js'
export default {
  name: 'MyCard',
  filters: {
    formatStat(type) {
      if (type === 0) {
        return '失效'
      } else if (type === 1) {
        return '有效'
      } else if (type === 2) {
        return '作废'
      } else if (type === 3) {
        return '退回'
      }
    },
    formatTime(time) {
      const dateString = time
      const date = new Date(dateString)

      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      // let hour = date.getHours()
      // let minute = date.getMinutes()
      // let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      // hour = hour < 10 ? '0' + hour : hour
      // minute = minute < 10 ? '0' + minute : minute
      // second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day} `
    }

  },
  props: {
    status: {
      type: Number,
      default: () => {
        return 1
      }
    }
  },
  data() {
    return {
      list: [],
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      orderParam: {
        pageNum: 1,
        pageSize: 10
        // status: 6,
      },
      periodOptions: [],
      typeOptions: [],
      statOptions: []
    }
  },
  mounted() {
    this.getGiftCardList()
  },
  methods: {
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.orderParam.pageNum = 1
      this.orderParam.pageSize = val
      this.getGiftCardList()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.orderParam.pageNum = val
      this.getGiftCardList()
    },
    // 查询列表
    getGiftCardList() {
      const params = {
        pageNum: this.orderParam.pageNum,
        pageSize: this.orderParam.pageSize,
        stat: this.status
      }
      cdkeyList(params).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
        } else {
          this.list = []
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
